<template>
  <div class="printer-wrap" :style="{ fontSize: size }">
    <div class="printer">
      <!-- cabeçalho -->
      <div class="printer__header">
        <div class="printer__led"></div>
        <div class="printer__model">PHOTONOW-2000</div>
      </div>

      <!-- slot de saída do papel (topo) -->
      <div class="printer__slot">
        <!-- <div class="sheet sheet--a">
          <div class="sheet__line"></div>
          <div class="sheet__line sheet__line--short"></div>
          <div class="sheet__line"></div>
          <div class="sheet__line sheet__line--mid"></div>
        </div>
        <div class="sheet sheet--b">
          <div class="sheet__line sheet__line--mid"></div>
          <div class="sheet__line"></div>
          <div class="sheet__line sheet__line--short"></div>
        </div> -->
        <div class="sheet sheet--c">
          <div class="sheet__image"></div>
          <div class="sheet__line"></div>
          <div class="sheet__image"></div>
        </div>
      </div>

      <!-- corpo -->
      <div class="printer__body">
        <div class="printer__input-slot"></div>
        <div class="printer__vents">
          <span></span><span></span><span></span><span></span><span></span>
        </div>
        <div class="printer__brand"><span></span><span></span></div>
      </div>

      <!-- base -->
      <div class="printer__base">
        <div class="printer__foot"></div>
        <div class="printer__foot"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "vImpressoraAnimation",
  props: {
    size: {
      type: String,
      default: "8px",
    },
  },
};
</script>

<style scoped>
/* ── base do componente — toda unidade usa `em` relativo ao `font-size` ── */
.printer-wrap {
  display: inline-flex;
  align-items: flex-start;
  justify-content: center;
}

.printer {
  position: relative;
  width: 22em;
  display: flex;
  flex-direction: column;
  align-items: center;
  filter: drop-shadow(0 0.6em 1.6em rgba(0, 0, 0, 0.35));
}

/* ── header ── */
.printer__header {
  width: 100%;
  height: 2.2em;
  background: linear-gradient(180deg, #3a3f52 0%, #2d3244 100%);
  border-radius: 0.7em 0.7em 0 0;
  display: flex;
  align-items: center;
  padding: 0 1.2em;
  gap: 0.8em;
  border-bottom: 0.15em solid #1e2233;
}

.printer__led {
  width: 0.75em;
  height: 0.75em;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 35%, #86efac, #22c55e);
  box-shadow: 0 0 0.5em 0.2em rgba(34, 197, 94, 0.7);
  animation: led-blink 1.6s ease-in-out infinite;
  flex-shrink: 0;
}

@keyframes led-blink {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
}

.printer__model {
  font-family: "Courier New", monospace;
  font-size: 0.75em;
  letter-spacing: 0.18em;
  color: rgba(255, 255, 255, 0.35);
  user-select: none;
}

/* ── slot de saída (onde o papel emerge) ── */
.printer__slot {
  position: relative;
  width: 17em;
  height: 1em;
  background: #111420;
  border-radius: 0.2em;
  margin: 0 auto;
  z-index: 2;
  box-shadow: inset 0 0.2em 0.6em rgba(0, 0, 0, 0.8);
  overflow: visible;
}

/* ── folhas de papel ── */
.sheet {
  position: absolute;
  left: 0.6em;
  right: 0.6em;
  /* começa dentro do slot */
  bottom: 0;
  height: 12em;
  background: linear-gradient(175deg, #fffef9 0%, #f0ede3 100%);
  border-radius: 0 0 0.3em 0.3em;
  padding: 1em 1.2em;
  display: flex;
  flex-direction: column;
  gap: 0.6em;
  transform-origin: top center;
  animation: paper-eject 2s cubic-bezier(0.4, 0, 0.2, 1) infinite both;
  will-change: transform, opacity;
  z-index: 1;
}

.sheet--a {
  animation-delay: 0s;
}
.sheet--b {
  animation-delay: 1s;
}
.sheet--c {
  animation-delay: 2s;
}

@keyframes paper-eject {
  /* folha totalmente dentro da impressora (coberta pelo corpo) */
  0% {
    transform: translateY(1em);
    opacity: 1;
  }
  /* desliza para fora pelo slot */
  32% {
    transform: translateY(3em);
    opacity: 1;
  }
  /* pausa visível */
  55% {
    transform: translateY(6em);
    opacity: 1;
  }
  /* começa a cair e sumir */
  80% {
    transform: translateY(10em);
    opacity: 1;
  }
  100% {
    transform: translateY(12em);
    opacity: 0;
  }
}

.sheet__line {
  height: 0.3em;
  background: #ccc9bf;
  border-radius: 0.2em;
  width: 100%;
}
.sheet__image {
  width: 100%;
  height: 4em;
  background: linear-gradient(180deg, #d1d0c5 0%, #b8b6ab 100%);
  border-radius: 0.2em;
}
.sheet__line--short {
  width: 55%;
}
.sheet__line--mid {
  width: 78%;
}

/* ── corpo da impressora ── */
.printer__body {
  width: 100%;
  background: linear-gradient(180deg, #2d3244 0%, #252938 60%, #1e2233 100%);
  padding: 1.4em 1.6em 1.6em;
  display: flex;
  flex-direction: column;
  gap: 1em;
  position: relative;
  z-index: 3;
}

/* slot de entrada de papel (parte de baixo) */
.printer__input-slot {
  height: 0.5em;
  background: #111420;
  border-radius: 0.2em;
  box-shadow: inset 0 0.15em 0.4em rgba(0, 0, 0, 0.7);
  margin: 0 1em;
}

.printer__vents {
  display: flex;
  gap: 0.5em;
  padding: 0 0.5em;
}

.printer__vents span {
  flex: 1;
  height: 0.3em;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 0.15em;
  box-shadow: inset 0 0.1em 0.2em rgba(0, 0, 0, 0.5);
}

.printer__brand {
  display: flex;
  gap: 0.4em;
  justify-content: flex-end;
  padding-right: 0.4em;
}

.printer__brand span {
  display: block;
  height: 0.35em;
  border-radius: 0.2em;
  background: rgba(255, 255, 255, 0.1);
}

.printer__brand span:first-child {
  width: 2.2em;
}

.printer__brand span:last-child {
  width: 1em;
}

/* ── base ── */
.printer__base {
  width: 100%;
  background: linear-gradient(180deg, #1e2233 0%, #171a29 100%);
  border-radius: 0 0 0.6em 0.6em;
  height: 1.6em;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 2em 0;
}

.printer__foot {
  width: 3em;
  height: 0.5em;
  background: #111420;
  border-radius: 0.15em 0.15em 0 0;
}
</style>
